/* eslint-disable import/prefer-default-export */
/**
 * Utilities for handling composite order keys (web_id + retailer_id)
 *
 * Strategy:
 * - order_key = base64(JSON.stringify({ webId, retailerId }))
 * - Allows separating both values when received in the payload
 * - Robust: handles any character in web_id (including |)
 * - Safe against collisions: unique web_id + unique retailer_id
 */

/**
 * Generates an order key from orderId and retailerId
 * @param {string} orderId - order's web_id (e.g.: SecureRandom.alphanumeric(10))
 * @param {number|string} retailerId - retailer's id
 * @returns {string} order key encoded in base64
 */
export const generateExternalKey = (orderId, retailerId) => {
  if (!orderId || !retailerId) {
    throw new Error('orderId and retailerId are required');
  }

  const payload = { orderId, retailerId };
  const json = JSON.stringify(payload);
  return btoa(json); // Encode in base64
};
